module.exports = "<div class=\"content\">\n    <div class=\"content\">\n        <h1>Ooops?!</h1>\n        <p>Die angeforderte Seite existiert nicht. Hast Du dich vielleicht vertippt?</p>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/artur/workspace/vscode/warpriders/src/app/content/404/not-found.component.html
// module id = ../../../../../src/app/content/404/not-found.component.html
// module chunks = 1